/* eslint-disable no-param-reassign */
import type { Draft } from '@reduxjs/toolkit';
import type { Release, ReleaseList } from '../../entities';

const getReleaseIndex = (draft: Draft<ReleaseList>, releaseId: string) =>
  draft.releases.findIndex((release) => release.id === releaseId);

export const updateReleaseInfo = (
  draft: Draft<ReleaseList>,
  updatedRelease: Release
) => {
  const releaseIndex = getReleaseIndex(draft, updatedRelease.id);
  if (releaseIndex >= 0) {
    draft.releases[releaseIndex] = updatedRelease;
  }
  return draft;
};

export const updateArtistNameInReleases = (
  draft: Draft<ReleaseList>,
  artistName: string
) => {
  draft.releases.forEach((release) => {
    release.artistName = artistName;
  });
  return draft;
};

export const addNewReleaseToList = (
  draft: Draft<ReleaseList>,
  newRelease: Release
) => {
  draft.releases.unshift(newRelease);
  return draft;
};

export const deleteReleaseFromList = (
  draft: Draft<ReleaseList>,
  releaseId: string
) => {
  const releaseIndex = getReleaseIndex(draft, releaseId);
  if (releaseIndex >= 0) {
    draft.releases.splice(releaseIndex, 1);
  }
  return draft;
};
